export default __webpack_public_path__ + "static/media/react_native_logo.cd867972.png";